import { useState, useEffect } from 'react';
import { useLang } from '../LangContext';
import translations from '../i18n';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const { lang } = useLang();
  const t = translations[lang].cookie;

  useEffect(() => {
    const consent = localStorage.getItem('rude_cookie_consent');
    if (!consent) setTimeout(() => setVisible(true), 1200);
  }, []);

  const acceptAll = () => { localStorage.setItem('rude_cookie_consent', 'all'); setVisible(false); };
  const acceptNecessary = () => { localStorage.setItem('rude_cookie_consent', 'necessary'); setVisible(false); };
  const savePreferences = () => { localStorage.setItem('rude_cookie_consent', analytics ? 'all' : 'necessary'); setVisible(false); };

  if (!visible) return null;

  if (showDetails) return (
    <div style={{
      position: 'fixed', bottom: '24px', left: '50%', transform: 'translateX(-50%)',
      zIndex: 9999, width: 'min(560px, calc(100vw - 48px))',
      background: 'rgba(8,8,8,0.98)', backdropFilter: 'blur(16px)',
      border: '1px solid rgba(229,0,60,0.3)', padding: '28px',
      animation: 'slideUp 0.4s cubic-bezier(0.16,1,0.3,1)',
    }}>
      <p style={{ fontFamily: 'var(--font-title)', fontWeight: 600, fontSize: '11px', letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--white)', marginBottom: '20px' }}>{t.manageTitle}</p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', border: '1px solid rgba(255,255,255,0.06)' }}>
          <div>
            <p style={{ fontFamily: 'var(--font-body)', fontWeight: 700, fontSize: '12px', color: 'var(--white)', marginBottom: '2px' }}>{t.technicalTitle}</p>
            <p style={{ fontFamily: 'var(--font-body)', fontSize: '11px', color: 'var(--gray-mid)' }}>{t.technicalDesc}</p>
          </div>
          <span style={{ fontFamily: 'var(--font-body)', fontSize: '10px', letterSpacing: '0.1em', color: 'var(--gray-mid)', textTransform: 'uppercase', flexShrink: 0, marginLeft: '12px' }}>{t.alwaysActive}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', border: '1px solid rgba(255,255,255,0.06)', cursor: 'pointer' }} onClick={() => setAnalytics(!analytics)}>
          <div>
            <p style={{ fontFamily: 'var(--font-body)', fontWeight: 700, fontSize: '12px', color: 'var(--white)', marginBottom: '2px' }}>{t.analyticsTitle}</p>
            <p style={{ fontFamily: 'var(--font-body)', fontSize: '11px', color: 'var(--gray-mid)' }}>{t.analyticsDesc}</p>
          </div>
          <div style={{ width: '40px', height: '22px', borderRadius: '11px', background: analytics ? 'var(--red)' : 'rgba(255,255,255,0.12)', position: 'relative', transition: 'background 0.3s', flexShrink: 0, marginLeft: '12px' }}>
            <div style={{ position: 'absolute', top: '3px', left: analytics ? '21px' : '3px', width: '16px', height: '16px', borderRadius: '50%', background: 'var(--white)', transition: 'left 0.3s' }} />
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
        <button onClick={() => setShowDetails(false)} style={{ background: 'none', border: '1px solid rgba(255,255,255,0.15)', cursor: 'pointer', fontFamily: 'var(--font-body)', fontSize: '11px', letterSpacing: '0.08em', color: 'var(--gray-mid)', padding: '8px 16px', transition: 'border-color 0.2s' }}
          onMouseEnter={e => e.target.style.borderColor = 'rgba(255,255,255,0.4)'}
          onMouseLeave={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'}
        >{t.backBtn}</button>
        <button onClick={savePreferences} style={{ background: 'var(--red)', border: 'none', cursor: 'pointer', fontFamily: 'var(--font-body)', fontSize: '11px', letterSpacing: '0.08em', color: 'var(--white)', padding: '8px 20px' }}>{t.saveBtn}</button>
      </div>
      <style>{`@keyframes slideUp { from { transform: translateX(-50%) translateY(20px); opacity:0; } to { transform: translateX(-50%) translateY(0); opacity:1; } }`}</style>
    </div>
  );

  return (
    <div style={{
      position: 'fixed', bottom: '24px', left: '50%', transform: 'translateX(-50%)',
      zIndex: 9999, width: 'min(640px, calc(100vw - 48px))',
      background: 'rgba(8,8,8,0.96)', backdropFilter: 'blur(16px)',
      border: '1px solid rgba(229,0,60,0.25)',
      padding: '16px 20px',
      display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap',
      animation: 'slideUp 0.4s cubic-bezier(0.16,1,0.3,1)',
    }}>
      <p style={{ fontFamily: 'var(--font-body)', fontSize: '12px', color: 'rgba(255,255,255,0.6)', lineHeight: 1.5, flex: 1, minWidth: '200px' }}>
        🍪 {t.text}{' '}
        <a href="/privacy" style={{ color: 'var(--red)', textDecoration: 'underline' }}>Privacy Policy</a>
      </p>
      <div style={{ display: 'flex', gap: '8px', flexShrink: 0, flexWrap: 'wrap' }}>
        <button onClick={() => setShowDetails(true)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'var(--font-body)', fontSize: '11px', color: 'rgba(255,255,255,0.35)', padding: '6px 0', transition: 'color 0.2s' }}
          onMouseEnter={e => e.target.style.color = 'var(--white)'}
          onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.35)'}
        >{t.manageBtn}</button>
        <button onClick={acceptNecessary} style={{ background: 'none', border: '1px solid rgba(255,255,255,0.2)', cursor: 'pointer', fontFamily: 'var(--font-body)', fontSize: '11px', letterSpacing: '0.06em', color: 'rgba(255,255,255,0.6)', padding: '6px 14px', transition: 'all 0.2s' }}
          onMouseEnter={e => { e.target.style.borderColor = 'rgba(255,255,255,0.5)'; e.target.style.color = 'var(--white)'; }}
          onMouseLeave={e => { e.target.style.borderColor = 'rgba(255,255,255,0.2)'; e.target.style.color = 'rgba(255,255,255,0.6)'; }}
        >{t.necessaryBtn}</button>
        <button onClick={acceptAll} style={{ background: 'var(--red)', border: 'none', cursor: 'pointer', fontFamily: 'var(--font-body)', fontSize: '11px', letterSpacing: '0.06em', color: 'var(--white)', padding: '6px 16px', transition: 'opacity 0.2s' }}
          onMouseEnter={e => e.target.style.opacity = 0.85}
          onMouseLeave={e => e.target.style.opacity = 1}
        >{t.acceptBtn}</button>
      </div>
      <style>{`@keyframes slideUp { from { transform: translateX(-50%) translateY(20px); opacity:0; } to { transform: translateX(-50%) translateY(0); opacity:1; } }`}</style>
    </div>
  );
}
